module.exports = __webpack_public_path__ + "media/images/social-icons/linkedin-dcf792e6d890fed3b2bcd136872c39af.svg";